import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ContactModel from 'donor-elf-web/models/contact';
import ContactsCache from 'donor-elf-web/services/contacts-cache';

export interface ContactMergeIndexRouteModel {
  contact: ContactModel;
  otherContacts: ContactModel[];
}

export default class ContactMergeIndexRoute extends Route {
  @service declare contactsCache: ContactsCache;

  model(): ContactMergeIndexRouteModel {
    let contactModel = this.modelFor('funds.fund.contacts.contact');
    let contact = contactModel.contact;
    return {
      contact: contact,
      otherContacts: this.contactsCache.contacts.filter((x) => {
        return x.id !== contact.id;
      }),
    };
  }
}
